export default "__VITE_ASSET__DfnosKTE__"